module.exports = __webpack_public_path__ + "static/media/plan-D3b-mobile-tc.7d188af7.png";